import {createSlice, PayloadAction} from '@reduxjs/toolkit';

export type ConsentValue = 'accepted' | 'declined' | undefined;
export interface GdprState {
    consent: ConsentValue;
}

export const initialState: GdprState = {
    consent: undefined,
};

const gdprSlice = createSlice({
    initialState,
    name: 'appgdpr',
    reducers: {
        updateConsent: (state: GdprState, action: PayloadAction<ConsentValue>) => {
            state.consent = action.payload
        },
    },
});

export const {
    updateConsent,
} = gdprSlice.actions;

export default gdprSlice